import {Component, inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import { HasPermissionDirective } from '@shared/directives/has-permission.directive';
import {ErrorService} from '../../../../../../shared/services/error.service';
import {SnackbarService} from '@shared/services/snackbar.service';
import {ContactosServiciosService} from '../contactos-servicios.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CreationButtons} from '../../../../../../shared/components/ui/creation-buttons/creation-buttons';
import {LabelComponent} from '../../../../../../shared/components/form/label/label.component';
import {CombosService} from '../../../../../../shared/services/combos.service';
import {GenericCombo} from '../../../../../../shared/services/interfaces/combos.interface';
import {forkJoin} from 'rxjs';
import {SelectFieldComponent, SelectOption} from '@shared/components/form/select/select-field.component';
import { AppFormComponent } from '@shared/components/ui/list-components';
import { Modal } from '@shared/components/common/modal/modal';

@Component({
  selector: 'app-crear-contacto-servicio',
  imports: [
    HasPermissionDirective,
    CreationButtons,
    FormsModule,
    LabelComponent,
    ReactiveFormsModule,
    SelectFieldComponent,
    AppFormComponent,
    Modal,
  ],
  templateUrl: './crear-contacto-servicio.html',
  styles: ``
})
export class CrearContactoServicio implements OnInit {

  saveForm!: FormGroup;
  loading = false;
  servicios: GenericCombo[] = [];

  get serviciosOptions(): SelectOption[] { return this.servicios.map(x => ({ value: x.id, label: x.nombre })); }

  private fB = inject(FormBuilder);
  private errorService = inject(ErrorService);
  private combosService = inject(CombosService);
  private snackbarService = inject(SnackbarService);
  private contactosServiciosService = inject(ContactosServiciosService);
  private dialogRef = inject(MatDialogRef<CrearContactoServicio>);
  private idContacto = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.getCombos();
    this.makeForm();
  }

  private getCombos(): void {
    const servicios = this.combosService.getServiciosCombo();

    forkJoin([servicios]).subscribe({
      next: (response) => {
        this.servicios = response[0].data;
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    });
  }

  private makeForm(): void {
    this.saveForm = this.fB.group({
      crm_contacto_id: [this.idContacto, Validators.required],
      param_servicio_id: ['', Validators.required],
    });
  }

  create(): void {
    this.loading = true;
    const jsonData = {
      ...this.saveForm.value,
      param_servicio_id: Number(this.saveForm.value.param_servicio_id),
    };

    this.contactosServiciosService.store(jsonData).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar('Servicio agregado al contacto correctamente');
          this.dialogRef.close(true);
        }
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  cancel(): void {
    this.saveForm.reset();
    this.dialogRef.close();
  }
}
